import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocchatService } from '@modules/hotel-booking/services/socchat-sevice/socchat.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-property',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './create-property.component.html',
  styleUrls: ['./create-property.component.scss'],
})
export class CreatePropertyComponent implements OnInit {
  isSidebarOpen = false;
  selectedSection = 'register';

  createSteps = [
    { key: 'general', label: 'General information' },
    { key: 'facilities', label: 'Hotel facilities' },
    { key: 'photos', label: 'Upload hotel photos' },
    { key: 'policies', label: 'Set property policies' },
    { key: 'rooms', label: 'Create rooms' },
    { key: 'review', label: 'Review hotel information and Submit the contract' },
    { key: 'rates', label: 'Set room rates (Rate plan)' },
    { key: 'calendar', label: 'Configure availability calendar' },
    { key: 'promotions', label: 'Create promotions' },
  ];

  channelSteps = [
    { key: 'hotelLink', label: 'Connect Hotel Link' },
    { key: 'cancel', label: 'Cancellation policy' },
    { key: 'roomSetup', label: 'Room setup' },
    { key: 'ratePlans', label: 'Rate plans' },
    { key: 'availability', label: 'Availability calendar' },
  ];

  constructor(
    private socchatService: SocchatService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.socchatService.setFloatChatBtn(false);
    // Check URL fragment on page load
    this.handleInitialFragment();
    // Add popstate listener for back/forward navigation
    window.addEventListener('popstate', this.handlePopState.bind(this));
  }

  private handleInitialFragment(): void {
    const fragment = window.location.hash.replace('#', '');
    if (fragment && this.isValidSection(fragment)) {
      this.selectedSection = fragment;
      setTimeout(() => this.scrollToSection(fragment), 30);
    }
  }

  private handlePopState(event: PopStateEvent): void {
    const fragment = window.location.hash.replace('#', '');
    if (fragment && this.isValidSection(fragment)) {
      this.selectedSection = fragment;
      this.scrollToSection(fragment);
    } else {
      this.selectedSection = 'register';
      this.scrollToSection('register');
    }
  }

  private isValidSection(key: string): boolean {
    const validIds = [
      'register',
      'create',
      'general',
      'facilities',
      'photos',
      'policies',
      'rooms',
      'review',
      'rates',
      'calendar',
      'promotions',
      'channel',
      'hotelLink',
      'cancel',
      'roomSetup',
      'ratePlans',
      'availability',
    ];
    return validIds.includes(key);
  }

  selectSection(key: string): void {
    if (this.isValidSection(key)) {
      // this.selectedSection = key;
      // Build full URL with pathname, search, and fragment
      const currentPath = window.location.pathname;
      const currentSearch = window.location.search;
      const newUrl = `${currentPath}${currentSearch}#${key}`;
      window.history.pushState(null, '', newUrl);
      this.scrollToSection(key);
      // this.isSidebarOpen = false; // Close sidebar on mobile
    }
  }

  private scrollToSection(key: string): void {
    const element = document.getElementById(key);
    if (element) {
      setTimeout(()=>{
        const yOffset = -80; // Match sticky header height
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }, 50);
    }
  }

  buttonClass(section: string): string {
    return this.selectedSection === section
      ? 'text-blue-600 font-semibold block text-left'
      : 'hover:text-blue-600 block text-left';
  }

  private updateSelectedSection(): void {
    const ids = [
      'register',
      'create',
      'general',
      'facilities',
      'photos',
      'policies',
      'rooms',
      'review',
      'rates',
      'calendar',
      'promotions',
      'channel',
      'hotelLink',
      'cancel',
      'roomSetup',
      'ratePlans',
      'availability',
    ];

    const targetY = 80; // Match yOffset in scroll
    let closestId: string | null = null;
    let minDistance = Number.MAX_VALUE;

    for (const id of ids) {
      const element = document.getElementById(id);
      if (!element) continue;

      const rectTop = element.getBoundingClientRect().top;
      const distance = Math.abs(rectTop - targetY);

      if (distance < minDistance) {
        minDistance = distance;
        closestId = id;
      }
    }

    if (closestId && closestId !== this.selectedSection) {
      this.selectedSection = closestId;
      // Build full URL with pathname, search, and fragment
      const currentPath = window.location.pathname;
      const currentSearch = window.location.search;
      const newUrl = `${currentPath}${currentSearch}#${closestId}`;
      window.history.replaceState(null, '', newUrl);
    }
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.updateSelectedSection();
  }

  navigateToBecameAgency() {
    const urlTree = this.router.createUrlTree(['ota-v2/become-an-agency']);
    const fullUrl = window.location.origin + this.router.serializeUrl(urlTree);
    window.open(fullUrl, '_blank');
  }
}